import React, { useState, useEffect } from 'react';
import { Button, Form, Radio, App } from 'antd';
import styles from './StorePublishProductStep3.module.scss';
import { IFormDataAll } from '../../types';
import { saveProduct } from '@/api/products';
import { useNavigate } from 'react-router-dom';

export interface StorePublishProductStep3Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  formData?: IFormDataAll;
}

// 产品发布第三步：物流服务
const StorePublishProductStep3: React.FC<StorePublishProductStep3Props> = ({
  onNext,
  onPrev,
  formData
}) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();

  const navigate = useNavigate();

  // 物流服务选项
  const [launchDate, setLaunchDate] = useState<string>('24hours');
  const [pickupMethod, setPickupMethod] = useState<number>(1);

  // 初始化数据
  useEffect(() => {
    if (formData) {
      setLaunchDate(formData.delivery_estimated_time || '24hours');
      setPickupMethod(formData.delivery_method || 1);
    }
  }, [formData]);



  // 处理提交
  const handleSubmit = () => {

     // 清理 formData，只保留需要的字段，避免包含事件对象
     const cleanFormData = {
      product_id: formData?.product_id || '',
      status: formData?.status || 1,
      is_delete: formData?.is_delete || false,
      product_category_id: formData?.product_category_id || null,
      product_category_brand_id: formData?.product_category_brand_id || null,
      product_spu_id: formData?.product_spu_id || null,
      product_title: formData?.product_title || '',
      product_status: formData?.product_status || 1,
      launch_option: formData?.launch_option || 'schedule',
      product_sku_values: formData?.product_sku_values || [],
      product_media_list: formData?.product_media_list || [],
      product_video_list: formData?.product_video_list || [],
      product_custom_attributes: formData?.product_custom_attributes || [],
      product_del_media_list: formData?.product_del_media_list || [],
      customize_SKU_attribute: formData?.customize_SKU_attribute || '',
      product_content: formData?.product_content || []
    };
    const submitData = {
      delivery_estimated_time: launchDate,
      delivery_method: pickupMethod,
    };

    const params = {
      ...cleanFormData,
      ...submitData
    };

    console.log('Form values:', params);

    saveProduct(params).then(res => {
      console.log('res:', res);
      if (res.code === 200) {
        message.success('Product saved successfully');
        navigate('/yourtownloop/yourProducts');
      } else {
        message.error('Product saved failed');
      }
    });
  };

  // 返回上一步
  const handlePrev = () => {

    onPrev && onPrev();
  };

  return (
    <div className={styles['store-publish-product-step3']}>
      <div className={styles['main-title']}>Logistics services</div>

      <Form form={form} layout="vertical">

        {/* 取货方式 */}
        <div className={styles['form-item']}>
          <div className={styles['form-label']}>* Pickup Method</div>
          <Radio.Group
            value={pickupMethod}
            onChange={(e) => setPickupMethod(e.target.value)}
            className={styles['radio-group']}
            disabled={true}
          >
            <Radio value={1} className={styles['radio-button']}>Pick up at store</Radio>
            {/* <Radio value={2} className={styles['radio-button']}>Provide home delivery service</Radio>
            <Radio value={3} className={styles['radio-button']}>Express delivery</Radio> */}

          </Radio.Group>
        </div>


        {/* 发货日期 */}
        {/* <div className={styles['form-item']}>
          <div className={styles['form-label']}>* Launch Date</div>
          <Radio.Group
            value={launchDate}
            onChange={(e) => setLaunchDate(e.target.value)}
            className={styles['radio-group']}
          >
            <Radio value="24hours" className={styles['radio-button']}>Ship Within 24 Hours</Radio>
            <Radio value="48hours" className={styles['radio-button']}>Ship Within 48 Hours</Radio>
          </Radio.Group>
        </div> */}




        {/* 按钮区域 */}
        <div className={styles['button-container']}>
          <Button
            className={styles['prev-button']}
            onClick={handlePrev}
          >
            Prev
          </Button>

          <Button
            type="primary"
            className={styles['next-button']}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default StorePublishProductStep3; 